<template>
  <v-card flat>
    <v-card-text class="pt-4">
      <v-form ref="form" v-model="isValid" @submit.prevent="submitForm">
        <v-row dense>
          <!-- خلاصه تنوع ووکامرس انتخابی -->
          <v-col cols="12" class="mb-2">
            <v-alert
              dense
              outlined
              color="indigo"
              class="mb-0 rounded-lg text-right"
            >
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="font-weight-bold text-truncate" style="max-width: 480px;">
                    {{ variantWoo?.name || 'تنوع انتخاب‌شده' }}
                  </div>
                  <div class="caption text--secondary mt-1">
                    <span>شناسه WP: <b>{{ variantWoo?.wp_id || variantWoo?.id }}</b></span>
                    <span v-if="variantWoo?.color" class="mr-3">رنگ: <b>{{ variantWoo?.color }}</b></span>
                    <span v-if="variantWoo?.sku" class="mr-3">کد SKU: <b>{{ variantWoo?.sku }}</b></span>
                  </div>
                </div>
                <!-- <v-chip
                  x-small
                  :color="isLinked ? 'teal lighten-5' : 'orange lighten-5'"
                  :text-color="isLinked ? 'teal darken-3' : 'orange darken-3'"
                  class="font-weight-bold"
                >
                  {{ isLinked ? 'متصل' : 'آماده اتصال' }}
                </v-chip> -->
              </div>
            </v-alert>
          </v-col>

          <!-- ۱. انتخاب محصول سامانه -->
          <v-col cols="12">
            <v-autocomplete
              ref="productSelect"
              v-model="payload.product_id"
              :items="localProducts"
              :loading="isLoadingProducts"
              :search-input.sync="searchProduct"
              item-value="id"
              item-text="title"
              label="محصول سامانه (جستجو با نام یا کد)"
              outlined
              dense
              clearable
              required
              :rules="[v => !!v || 'انتخاب محصول سامانه الزامی است']"
              prepend-inner-icon="mdi-magnify"
              placeholder="نام یا کد محصول سامانه را تایپ کنید..."
              no-filter
            >
              <!-- آیتم انتخاب‌شده در فیلد -->
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center text-truncate py-1">
                  <v-avatar size="26" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                    <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain />
                    <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                  </v-avatar>
                  <v-chip x-small color="primary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                  <span class="text-truncate">{{ item.title }}</span>
                </div>
              </template>

              <!-- لیست گزینه‌های منو -->
              <template v-slot:item="{ item }">
                <v-list-item-avatar size="42" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                  <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain>
                    <template #placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate size="16" color="grey lighten-1" />
                      </v-row>
                    </template>
                  </v-img>
                  <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-body-2 mb-1" style="line-height: 1.4;">
                    {{ item.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex align-center">
                    <v-chip x-small color="primary" outlined class="font-mono font-weight-bold">
                      کد: {{ item.id }}
                    </v-chip>
                    <span v-if="item.sku" class="text-caption grey--text mr-2">
                      SKU: {{ item.sku }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
                      </v-col>

         <!-- انتخاب تنوع محصول در صورت وجود تنوع -->
          <v-col cols="12" v-if="localSKUProducts.length > 0">
            <v-autocomplete
              v-model="payload.product_sku_id"
              :items="localSKUProducts"
              :loading="isLoadingSKUProducts"
              item-value="id"
              item-text="title"
              label="تنوع سامانه (جستجو با نام یا کد)"
              outlined
              dense
              clearable
              required
              :rules="[v => !!v || 'انتخاب تنوع محصول سامانه الزامی است']"
              prepend-inner-icon="mdi-shape-outline"
              placeholder="نام یا کد تنوع سامانه را تایپ کنید..."
            >
              <!-- تنوع انتخاب‌شده داخل فیلد -->
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center text-truncate py-1">
                  <v-avatar size="26" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                    <v-img v-if="getSkuImage(item)" :src="getSkuImage(item)" aspect-ratio="1" contain />
                    <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                  </v-avatar>
                  <v-chip x-small color="secondary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                  <span class="text-truncate">{{ item.title || item.sku }}</span>
                </div>
              </template>

              <!-- گزینه‌های لیست کشویی تنوع‌ها -->
              <template v-slot:item="{ item }">
                <v-list-item-avatar size="42" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                  <v-img v-if="getSkuImage(item)" :src="getSkuImage(item)" aspect-ratio="1" contain>
                    <template #placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate size="16" color="grey lighten-1" />
                      </v-row>
                    </template>
                  </v-img>
                  <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-body-2 mb-1">
                    {{ item.title || item.sku || ('تنوع ' + item.id) }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="d-flex align-center flex-wrap gap-1">
                    <v-chip x-small color="secondary" outlined class="font-mono font-weight-bold ml-1">
                      ID: {{ item.id }}
                    </v-chip>

                    <v-chip v-if="item.sku" x-small color="grey darken-1" outlined class="font-mono ml-1">
                      {{ item.sku }}
                    </v-chip>

                    <span v-if="item.color_title || item.color?.title" class="text-caption grey--text text--darken-2 mr-1">
                      رنگ: {{ item.color_title || item.color?.title }}
                    </span>

                    <span v-if="item.size_title || item.size?.title" class="text-caption grey--text text--darken-2 mr-1">
                      سایز: {{ item.size_title || item.size?.title }}
                    </span>

                    <v-chip v-if="item.stock !== undefined" x-small :color="item.stock > 0 ? 'success' : 'error'" text class="mr-auto">
                      موجودی: {{ item.stock }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- ۳. تعداد در بسته -->
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="payload.package_quantity"
              label="تعداد در بسته"
              outlined
              dense
              type="number"
              min="1"
              required
              :rules="[
                v => !!v || 'وارد کردن تعداد در بسته الزامی است',
                v => v > 0 || 'تعداد باید حداقل ۱ باشد'
              ]"
              prepend-inner-icon="mdi-package-variant-closed"
            />
          </v-col>

          <!-- ۴. هزینه هر بسته -->
          <v-col cols="12" md="6">
            <PriceInput
              v-model="payload.package_cost"
              label="هزینه هر بسته (تومان)"
              prepend-inner-icon="mdi-cash"
              outlined
              dense
              :rules="[v => (v !== null && v !== undefined && v !== '') || 'وارد کردن هزینه بسته الزامی است']"
            />
          </v-col>

          <!-- ۵. سوییچ‌های همگام‌سازی قیمت و موجودی -->
          <!-- <v-col cols="12">
            <v-card outlined class="pa-3 rounded-lg grey lighten-5">
              <div class="subtitle-2 font-weight-bold mb-2 grey--text text--darken-2">
                تنظیمات همگام‌سازی خودکار ووکامرس
              </div>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-switch
                    v-model="payload.sync_price"
                    label="همگام‌سازی خودکار قیمت"
                    color="primary"
                    dense
                    hide-details
                    class="mt-1"
                  />
                  <small class="grey--text d-block mr-8">
                    تغییر قیمت سامانه در ووکامرس اعمال شود.
                  </small>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-switch
                    v-model="payload.sync_stock"
                    label="همگام‌سازی خودکار موجودی انبار"
                    color="success"
                    dense
                    hide-details
                    class="mt-1"
                  />
                  <small class="grey--text d-block mr-8">
                    تغییر موجودی سامانه در ووکامرس به‌روز شود.
                  </small>
                </v-col>
              </v-row>
            </v-card>
          </v-col> -->
        </v-row>
      </v-form>
    </v-card-text>

    <!-- اکشن‌ها -->
    <v-card-actions class="grey lighten-4 pa-4 d-flex align-center">
      <v-btn class="btn-delete rounded-lg" @click="$emit('close')">
        <v-icon left>mdi-close</v-icon>
        انصراف
      </v-btn>

      <v-btn
        v-if="isLinked"
        outlined
        class="btn-refund rounded-lg mr-2"
        :loading="isUnlinking"
        :disabled="isSubmitting"
        @click="unlinkVariant"
      >
        <v-icon left>mdi-link-off</v-icon>
        قطع اتصال
      </v-btn>

      <v-spacer />

      <v-btn
        class="btn-get-code rounded-lg"
        :loading="isSubmitting"
        :disabled="!isValid || isUnlinking"
        @click="submitForm"
      >
        <v-icon left>mdi-link-variant-plus</v-icon>
        ثبت و اتصال تنوع
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceInput from "../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";

export default {
  name: "LinkWooVariantModal",
  components: {
    PriceInput,
  },
  props: {
    variantWoo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isValid: false,
      isSubmitting: false,
      isUnlinking: false,
      isLinked: false,
      isInitialLoading: false, // جلوگیری از تداخل واچر هنگام مقداردهی اولیه

      localProducts: [],
      isLoadingProducts: false,
      searchProduct: null,
      searchTimeout: null,

      localSKUProducts: [],
      isLoadingSKUProducts: false,

      payload: {
        product_id: null,
        product_sku_id: null,
        package_quantity: 1,
        package_cost: 0,
        sync_price: true,
        sync_stock: true,
      },
    };
  },
  watch: {
    searchProduct(val) {
      if (!val || val.length < 2) return;
      if (this.isLoadingProducts) return;

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchLocalProducts(val);
      }, 500);
    },
    async "payload.product_id"(newVal, oldVal) {
      // اگر در مرحله لود اولیه و پر کردن داده‌های قبلی هستیم، مقدار SKU را صفر نکن
      if (this.isInitialLoading) return;

      if (oldVal && newVal !== oldVal) {
        this.payload.product_sku_id = null;
        this.localSKUProducts = [];
      }

      if (newVal) {
        await this.fetchLocalSKUProducts(newVal);
      }
    },
  },
  async mounted() {
    this.resetForm();
    await this.fetchLocalProducts("");
    await this.fetchLinkData();

    if (!this.isLinked) {
      this.openProductDropdownIfEmpty();
    }
  },
  methods: {
      getSkuImage(sku) {
      if (!sku) return "";

      // 1. بررسی فیلدهای مستقیم تصویر در تنوع
      let img = sku.main_image?.url|| sku.image || sku.thumbnail || sku.cover || sku.img_url;

      // 2. بررسی آرایه تصاویر/گالری تنوع
      if (!img && (Array.isArray(sku.images) || Array.isArray(sku.gallery))) {
        const list = sku.images || sku.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }

      // 3. Fallback: اگر تنوع خودش تصویر نداشت، از تصویر محصول والد انتخاب‌شده استفاده کن
      if (!img && this.payload.product_id) {
        const parentProduct = this.localProducts.find(p => p.id === this.payload.product_id);
        if (parentProduct) {
          img = this.getItemImage(parentProduct);
        }
      }

      if (!img) return "";

      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }

      return img;
    },
      getItemImage(item) {
      if (!item) return "";

      let img = item.main_image?.url || item.image || item.cover || item.cover_image || item.img_url;

      if (!img && (Array.isArray(item.images) || Array.isArray(item.gallery))) {
        const list = item.images || item.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }

      if (!img) return "";

      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }

      return img;
    },
    resetForm() {
      this.isLinked = false;
      this.payload = {
        product_id: null,
        product_sku_id: null,
        package_quantity: 1,
        package_cost: 0,
        sync_price: true,
        sync_stock: true,
      };
      this.localSKUProducts = [];
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    openProductDropdownIfEmpty() {
      this.$nextTick(() => {
        if (!this.payload.product_id && this.$refs.productSelect) {
          this.$refs.productSelect.focus();
          this.$refs.productSelect.isMenuActive = true;
        }
      });
    },

    async fetchLinkData() {
      // استفاده از wp_id یا external_variant_id یا id موجود در پراپ
      const variantId = this.variantWoo?.wp_id || this.variantWoo?.external_variant_id || this.variantWoo?.id;
      if (!variantId) return;

      this.isInitialLoading = true;

      try {
        const res = await this.$api.get(`/v1/marketplace-listings/digi/get-listing`, {
          params: { variant_id: variantId, marketplace: "woocommerce" },
        });

        // استخراج داده listing از ریسپانس دریافتی
        const resData = res?.data?.data || res?.data || {};
        const listing = resData.listing;

        // اگر لیسیتنگ متصل شده وجود داشت (حالت ویرایش)
        if (listing && listing.product_id) {
          this.isLinked = true;
          const pId = Number(listing.product_id);

          // ۱. قرار دادن محصول در لیست انتخابی اگر از قبل نبود
          if (!this.localProducts.some((p) => p.id === pId)) {
            this.localProducts.unshift({
              id: pId,
              title: listing.product?.title || `محصول شماره ${pId}`,
            });
          }

          // ۲. دریافت لیست تنوع‌های سامانه
          await this.fetchLocalSKUProducts(pId);

          // ۳. اگر تنوع جاری در لیست SKU نبود، مستقیماً به لیست اضافه کن تا لیبل نمایش داده شود
          if (listing.sku && !this.localSKUProducts.some((s) => s.id === listing.sku.id)) {
            this.localSKUProducts.unshift({
              id: Number(listing.sku.id),
              title: listing.sku.title,
              sku: listing.sku.sku,
            });
          }

          // ۴. پر کردن فیلدهای فرم
          this.payload = {
            product_id: pId,
            product_sku_id: listing.product_sku_id ? Number(listing.product_sku_id) : null,
            package_quantity: listing.package_quantity ?? 1,
            package_cost: listing.package_cost ?? 0,
            sync_price: listing.sync_price ?? true,
            sync_stock: listing.sync_stock ?? true,
          };
        } else {
          // حالت ایجاد جدید (اتصالی وجود ندارد)
          this.resetForm();
        }
      } catch (e) {
        // در صورت عدم یافتن یا خطا، حالت اتصال جدید در نظر گرفته شود
        this.resetForm();
      } finally {
        this.$nextTick(() => {
          this.isInitialLoading = false;
        });
      }
    },

    async fetchLocalProducts(searchQuery = "") {
      this.isLoadingProducts = true;
      try {
        const { data } = await this.$api.get(`/v1/products/list`, {
          params: { search: searchQuery },
        });
        const items = data?.data?.data || data?.data || data || [];
        this.localProducts = Array.isArray(items) ? items : [];
      } catch (error) {
        console.error("خطا در جستجوی محصولات سامانه", error);
      } finally {
        this.isLoadingProducts = false;
      }
    },

    async fetchLocalSKUProducts(productId) {
      if (!productId) return;
      this.isLoadingSKUProducts = true;
      try {
        const { data } = await this.$api.get(`/v1/products/${productId}/sku-list`);
        const skus = data?.data || data || [];
        this.localSKUProducts = Array.isArray(skus) ? skus : [];
      } catch (error) {
        console.error("خطا در دریافت لیست تنوع‌های سامانه", error);
        this.localSKUProducts = [];
      } finally {
        this.isLoadingSKUProducts = false;
      }
    },

    async unlinkVariant() {
      const confirmed = this.$modal?.yesNo
        ? await this.$modal.yesNo("آیا از قطع اتصال این تنوع ووکامرس به سامانه اطمینان دارید؟")
        : confirm("آیا از قطع اتصال این تنوع اطمینان دارید؟");

      if (!confirmed) return;

      this.isUnlinking = true;
      try {
        const variantId = this.variantWoo?.wp_id;
        await this.$api.post(`v1/marketplace-listings/unlink-by-variant`,{  "marketplace": "woocommerce", 
          "external_variant_id": variantId});
        this.$toast?.success("اتصال با موفقیت قطع گردید.");
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در قطع اتصال");
      } finally {
        this.isUnlinking = false;
      }
    },

    async submitForm() {
      if (this.$refs.form && !this.$refs.form.validate()) return;

      this.isSubmitting = true;
      try {
        const apiPayload = {
          product_id: Number(this.payload.product_id),
          product_sku_id: this.payload.product_sku_id ? Number(this.payload.product_sku_id) : null,
          wp_variant_id: Number(this.variantWoo?.wp_id || this.variantWoo?.id),
          package_quantity: Number(this.payload.package_quantity) || 1,
          package_cost: Number(String(this.payload.package_cost || 0).replace(/,/g, "")),
          sync_price: Boolean(this.payload.sync_price),
          sync_stock: Boolean(this.payload.sync_stock),
        };

        await this.$api.post("/v1/woocommerce/variants/link", apiPayload);

        this.$toast?.success(
          this.isLinked
            ? "ویرایش اتصال با موفقیت ثبت شد."
            : "تنوع ووکامرس با موفقیت متصل شد."
        );
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در ثبت اتصال تنوع");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>